import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon"];

  toggle(event) {
    const isExpanded = event.currentTarget.getAttribute("aria-expanded") === "true";
    this.iconTarget.textContent = isExpanded ? "-" : "+";
  }
}
